import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/response-model.model';
import { DataService } from 'src/app/shared/services/data.service';

@Injectable({
  providedIn: 'root'
})
export class InstallmentReportService {
  public previousrowClickedId: number;
  public sundryType: string;

  constructor(  public service:DataService,) { }

  getallinstallmentfundreportledgerlist(data):Observable<ResponseModel>{
    let url = "api/app/installmentfundreport/getallinstallmentfundreportledgerlist";
    const json = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getlistofschemesbyledgerid(data):Observable<ResponseModel>{
    let url = "api/app/installmentfundreport/getlistofschemesbyledgerid";
    const json = JSON.stringify(data);
    return this.service.post(url, data, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
}

